import {useEffect} from 'react';
import {createAsyncThunk, createSlice, isAnyOf, AsyncThunk} from '@reduxjs/toolkit'
import {createBrowserHistory} from "history";
import {RootState} from "../store/store";
import {AppServices} from "../../config/entities";
import {useNavigate} from 'react-router-dom';
import {IUser} from "../../dtos/identity/IUser";

const history = createBrowserHistory();

const storedUser = localStorage.getItem("selectAuthUser");

interface AccountState {
    token?: string;
    tokenExpire?: string;
    user?: IUser;
    loginStatus: "none" | "pending" | "fulfilled" | "rejected";
    isAuthenticated: boolean;
    logoutTimer?: ReturnType<typeof setTimeout>; // new property
    

    defaultCompanyId?: string;
    defaultWarehouseId?: string;
    defaultCurrencyId?: string;
    defaultDivisionId?: string;
}


const initialState: AccountState = {
    token: undefined,
    tokenExpire: undefined,
    user: storedUser ? JSON.parse(storedUser) : undefined,
    loginStatus: "none",
    isAuthenticated: true,
}


export const signInUser = createAsyncThunk(
    "Identity/login",
    async (data: any, thunkAPI) => {
        try {
            const tokenData = await AppServices.IdentityService.login(data.username, data.password);
            localStorage.setItem("userData", JSON.stringify(tokenData));

            const {token, tokenExpire}: any = tokenData;
            thunkAPI.dispatch(accountSlice.actions.setToken(token));
            thunkAPI.dispatch(accountSlice.actions.setTokenExpire(tokenExpire));

            const tokenExpireMs = new Date(tokenExpire).getTime() - Date.now();
            const logoutTimeMs = tokenExpireMs - 60 * 100;
            thunkAPI.dispatch(accountSlice.actions.setLogoutTimer(setTimeout(() => {
                thunkAPI.dispatch(doLogout());
            }, logoutTimeMs)));

            return tokenData;
        } catch (error) {
            return thunkAPI.rejectWithValue({error: "unauthorized"});
        }
    }
);

export const fetchCurrentUser = createAsyncThunk(
    "Identity/current-user",
    async (data: any, thunkAPI) => {
        try {
            const user = await AppServices.IdentityService.currentUser();
            localStorage.setItem("userData", JSON.stringify(user));
            return user;
        } catch (error) {
            //@ts-ignore
            return thunkAPI.rejectWithValue({error: error.data});
        }
    }
);

export const accountSlice = createSlice({
    name: "account",
    initialState,
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload;
        },
        setTokenExpire: (state, action) => {
            state.tokenExpire = action.payload;
        },
        setLogoutTimer: (state, action) => {
            state.logoutTimer = action.payload;
        },
        doLogout: state => {
            state.token = undefined;
            state.user = undefined;
            console.log(state.loginStatus)
            //state.userPermissions = [];
            localStorage.removeItem("userData");
            state.isAuthenticated = true;
            history.push("/");
            state.loginStatus = 'none';
        }
    },
    extraReducers: (builder => {
        builder.addMatcher(isAnyOf(signInUser.fulfilled, fetchCurrentUser.fulfilled),
            (state, action) => {
                const tokenData = action.payload;
                if (tokenData) {
                    const {token, tokenExpire} = tokenData;
                    state.token = token;
                    const claims = JSON.parse(atob(token.split('.')[1]));
                    let roles = claims["Roles"];
                    if (typeof roles === "string") {
                        roles = [roles];
                    }
                    state.user = {
                        userName: claims["UserName"],
                        lockoutEnabled: false,
                        roles
                    }
                    //state.userPermissions = AppServices.PermissionService.getPermissionsByRole(roles);
                    AppServices.Axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
                }
                localStorage.setItem("selectAuthUser", JSON.stringify(state.user));

                state.loginStatus = "fulfilled";
                state.isAuthenticated = true;
            });

        builder.addMatcher(isAnyOf(signInUser.pending, fetchCurrentUser.pending), (state, action) => {
            state.loginStatus = "pending";
            state.isAuthenticated = true;

        });

        builder.addMatcher(isAnyOf(signInUser.rejected, fetchCurrentUser.rejected), (state, action) => {
            state.loginStatus = "rejected";
            state.isAuthenticated = true;
        });
    })
});

export const {setToken, setTokenExpire, setLogoutTimer} = accountSlice.actions;

export const {doLogout} = accountSlice.actions;

export const selectAuthToken = (state: RootState) => state.account.token;
export const selectAuthUser = (state: RootState) => state.account.user;
// export const selectUserPermissions = (state: RootState) => state.account.userPermissions;
export const selectLoginStatus = (state: RootState) => state.account.loginStatus;


// export const selectUserSettings = (state:RootState) => state.userSettings.settings
// export const selectRandomNumber = (state:RootState) => state.userSettings.randomNumber
// export const selectUserSettingsLoading = (state:RootState) => state.userSettings.loading
// export const selectUserSettingsError = (state:RootState) => state.userSettings.error

export const account = accountSlice.reducer;
// export const userSettings = userSettingsSlice.reducer;